<div class="message-center-header flex w-full">
  <div class="message-center-header__container flex flex-none">
    <h1 class='title'>Message Center ({{ unreadCount }})</h1>
  </div>
  <div class="flex flex-grow-1"></div>
  <div class="flex flex-none">
    <ng-content>

    </ng-content>
  </div>
</div>
